import React, { useState } from "react";
import styled from "styled-components";
import RegByRep from "./Trials/regByRep"
import RegByRepWithRegion from "./Trials/regByRepWithRegion"

function TrialSignUpsRepWithRegionExplorer() {
  const [searchBy, setSearchBy] = useState("dd"); // 'week' or 'dd'
  const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
  const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";

  const handleChangeTimeFrame = () => {
    setSearchBy(searchBy === "dd" ? "week" : "dd");
  };

  return (
    <Container>
      <h1>
        New Sign-ups only by Representation with trial
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      <h2>{currentDateLabel} by Representation</h2>
      <RegByRep date={searchBy} />
      <hr />

      <br />
      <h2>{currentDateLabel} by Representation with Region</h2>
      <RegByRepWithRegion date={searchBy} />
      <hr />
    </Container>
  );
}

const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default TrialSignUpsRepWithRegionExplorer;